export const state = {
  printParams: null,
  printMode: false,
  tableMode: false
};
